import React, { Fragment, Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { IObservationEvent } from "../../interfaces/IObservationEvent";
import { Button, List, Modal, ModalProps, Segment } from "semantic-ui-react";
import { PersonName } from "../person/PersonName";
import _format from "date-fns/format";
import ObservationPackageDetails from "./ObservationPackageModal";

const getTextProps = (t: TFunction) => ({
    modalHeader: t("Muokkaushistoria"),
    close: t("Sulje"),
    closeEvent: t("Sulje tapahtuma"),
    showDetails: t("Näytä tiedot")

})

interface ObservationHistoryModalProps extends Omit<ModalProps, "onClose" | "onOpen" | "open"> {
    events: Array<IObservationEvent>;
};

const ObservationHistoryModal: React.FC<ObservationHistoryModalProps> = ({ events, ...props }) => {
    const texts = getTextProps(useTranslation().t);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<IObservationEvent>()

    const renderItem = (event: IObservationEvent) => {
        const select = () => setSelected(event);
        return (
            <List.Item key={event.id} >
                <List.Header>  {event.title} </List.Header>
                <div>
                    {event.timestamp ? _format(event.timestamp, "dd.MM.yyyy HH:mm") : null}{" "}
                    {event.performer && <PersonName personId={event.performer} />}
                </div>
                <a onClick={select}> {texts.showDetails} </a>
            </List.Item>
        )
    }

    const orderByDate = (a: IObservationEvent, b: IObservationEvent) => {
        return (b.timestamp?.getTime() || 0) - (a.timestamp?.getTime() || 0);
    };

    const eventsContainingPackage = events.sort(orderByDate).filter((event, index, arr) => event.historyPackageId && index !== (arr.length - 1));

    return (
        <Modal
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            closeIcon
        >
            <Modal.Header >
                {selected?.title || texts.modalHeader}
                {selected && (
                    <Fragment>
                        <br />
                        <small>
                            {selected.timestamp ? _format(selected.timestamp, "dd.MM.yyyy HH:mm") : null}{" "}
                            {selected.performer && <PersonName personId={selected.performer} />}
                        </small>
                    </Fragment>
                )}
            </Modal.Header>
            <Modal.Content style={{ maxHeight: "500px", overflowY: "scroll" }}>
                {selected && selected.historyPackageId ? (
                    <Suspense fallback={<Segment basic placeholder loading />}>
                        <ObservationPackageDetails packageId={selected.historyPackageId} />
                    </Suspense>
                ) : (
                    <List relaxed>
                        {eventsContainingPackage.map(renderItem)}
                    </List>
                )}

            </Modal.Content>
            <Modal.Actions>
                {selected && (
                    <Button content={texts.closeEvent} onClick={() => setSelected(undefined)} />
                )}
                <Button content={texts.close} onClick={() => setOpen(false)} />
            </Modal.Actions>
        </Modal>
    )
}



export default ObservationHistoryModal;
